/*
 * @Description: 数据场景应用，分两个方面，在线图层服务，数据应用场景
 * @Author: JokerShaw
 * @Date: 2023-06-15 10:17:20
 * @LastEditTime: 2023-07-25 14:02:28
 * @FilePath: \yd_yg_test_project_new\src\components\GlobeTool\SenceApplicationBox\SenceApplicationBox.js
 */

import React, { Component } from 'react'
import './SecenApplicationBox.css'
import searchIcon from '../statics/icon-search.png'
import nodata from '../statics/nodata.png'
import dataDetail from '../statics/dataDetail.png'
import axios from 'axios'
import { message, Pagination, Spin, Skeleton } from 'antd'

export default class SenceApplicationBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSensingButtonChecked: true,//默认选择遥感影像按钮
            isTopicUnityButtonChecked: false,//专题集锦按钮是否被选中
            isProductLaunchesButtonChecked: false,//产品发布按钮是否被选中
            switchSceneBoxDisplayStatus: 'none',//初始让场景应用界面不显示
            switchSceneDetailStatus: 'none',//初始让数据详情框不显示
            sensingImageDataList: [],//存放查询到的遥感影像服务
            phaseImageDataList: [],//存放查询到的时相数据
            currentcheckedSceneData: {},//当前选中的遥感影像数据
            currentPageNumber: 1,//初始化页码
            totalElement: 0,//初始化数据总量
            searchKeyword: '',//检索关键字
            sliderShow: false,
            spinning: false
        }
    }


    componentDidMount() {
        this.setState({
            switchSceneBoxDisplayStatus: this.props.visible ? 'flex' : 'none'
        })
        // this.getSensingImageSource(1)
    }

    componentDidUpdate(preProps, preState) {
        if (preProps.visible !== this.props.visible) {
            this.setState({
                switchSceneBoxDisplayStatus: this.props.visible ? 'flex' : 'none'
            })
        }
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //   if (this.state.sensingImageDataList === nextState.sensingImageDataList) {
    //     return false
    //   }
    // }
    /**
     * @description: 关闭应用场景弹窗
     * @event: closeSceneBox
     * @return {*}
     */
    closeSceneBox = () => {
        this.setState({
            switchSceneBoxDisplayStatus: 'none'
        })
        this.props.changeVisibleStatus()
    }
    /**
     * @description: 关闭场景详情弹窗
     * @event: closeScendDetailBox
     * @return {*}
     */
    closeScendDetailBox = () => {
        if (this.state.sliderShow) {
            this.controlSlider()
        }
        this.setState({
            switchSceneDetailStatus: 'none'
        })
        this.props.changeVisibleStatus()
        this.clearCheckedServerLayer()
        document.getElementsByClassName("cesium-viewer-timelineContainer")[0].style.display = "none"
        document.getElementsByClassName("cesium-viewer-animationContainer")[0].style.display = "none"
    }
    /**
     * @description: 返回专题场景弹窗
     * @event: backScendDisplayBox
     * @return {*}
     */
    backScendDisplayBox = () => {
        if (this.state.sliderShow) {
            this.controlSlider()
        }
        this.setState({
            switchSceneBoxDisplayStatus: 'flex',
            switchSceneDetailStatus: 'none'
        })
        this.props.setSliderShow(false)
        this.clearCheckedServerLayer()
        document.getElementsByClassName("cesium-viewer-timelineContainer")[0].style.display = "none"
        document.getElementsByClassName("cesium-viewer-animationContainer")[0].style.display = "none"
    }
    /**
     * @description: 切换按钮
     * @event: switchDisplayImage
     * @param {*} buttonName
     * @return {*}
     */
    switchDisplayImage = async (buttonName) => {
        switch (buttonName) {
            case '遥感影像':
                this.setState({
                    isSensingButtonChecked: true,//默认选择遥感影像按钮
                    isTopicUnityButtonChecked: false,//专题集锦按钮是否被选中
                    isProductLaunchesButtonChecked: false,
                    // sensingImageDataList:[]
                })
                this.getSensingImageSource(1)
                break;
            case '专题集锦':
                this.setState({
                    isSensingButtonChecked: false,//默认选择遥感影像按钮
                    isTopicUnityButtonChecked: true,//专题集锦按钮是否被选中
                    isProductLaunchesButtonChecked: false,//产品发布按钮是否被选中
                    // sensingImageDataList:[]
                })
                this.getPhaseImageSource(1)
                break;
            case '产品发布':
                this.setState({
                    isSensingButtonChecked: false,//默认选择遥感影像按钮
                    isTopicUnityButtonChecked: false,//专题集锦按钮是否被选中
                    isProductLaunchesButtonChecked: true,//产品发布按钮是否被选中
                    // sensingImageDataList:[]
                })
                // this.getPhaseImageSource(1)
                this.getProductImageSource(1);
                break;
            default:
                break;
        }
    }
    /**
     * @description: 获取遥感影像数据
     * @event: getSensingImageSource
     * @return {*}
     */
    getSensingImageSource = async (pageNumber, title = '') => {
        // console.log(pageNumber,title)
        let params = {
            title: title,
            data_type: 0,
            isAsc: 'DESC',
            layer_type: 0,
            orderByColumn: "createDate",
            page: pageNumber,
            size: 10
        }
        this.setState({
            spinning: true,
            sensingImageDataList: []
        })
        await axios.post(`/getonlineImage/api/layer/query`, params).then(res => {
            // console.log('getSensingImageSource', sensingRes)
            const { data: sensingRes } = res
            if (sensingRes.code === 200) {
                if (sensingRes.data.content.length === 0) {
                    this.setState({
                        totalElement: 0,
                        currentPageNumber: 1
                    })
                }
                sensingRes.data.content && sensingRes.data.content.map(async (element, index) => {
                    const { data: thumbPathRes } = await axios.get(`/getonlineImage/api/gisfile/detail/${element.gisFileId}`)
                    if (thumbPathRes.code === 200) {
                        sensingRes.data.content[index]['thumbnailPath'] = 'http://124.16.188.131:9891' + thumbPathRes.data.thumbnailPath
                        sensingRes.data.content[index]['isLoading'] = 'noLoad'
                        this.setState({
                            totalElement: sensingRes.data.totalElements,
                            sensingImageDataList: sensingRes.data.content,
                        })
                    } else {
                        message.error('缩略图获取失败')
                    }
                })
            } else {
                message.error("遥感影像获取失败")
            }
        }).catch(e => {
            message.error("遥感影像获取失败")
        }).finally(() => {
            this.setState({
                spinning: false
            })
        })
    }
    /**
     * @description: 获取时相数据
     * @event: getPhaseImageSource
     * @param {*} pageNumber
     * @return {*}
     */
    getPhaseImageSource = async (pageNumber, title = '') => {
        let params = {
            title: title,
            data_type: 0,
            isAsc: 'DESC',
            layer_type: 2,
            orderByColumn: "createDate",
            page: pageNumber,
            size: 10
        }
        this.setState({
            spinning: true,
            sensingImageDataList: []
        })
        await axios.post(`/getonlineImage/api/layer/query`, params).then(res => {
            const { data: phaseRes } = res
            // console.log('getPhaseImageSource', phaseRes)
            if (phaseRes.code === 200) {
                if (phaseRes.data.content.length === 0) {
                    this.setState({
                        totalElement: 0,
                        currentPageNumber: 1
                    })
                }
                phaseRes.data.content && phaseRes.data.content.map(async (element, index) => {
                    const { data: phaseDetailRes } = await axios.get(`/getonlineImage/api/gisfile/detail/${element.gisFileId}`)
                    if (phaseDetailRes.code === 200) {
                        phaseRes.data.content[index]['thumbnailPath'] = 'http://124.16.188.131:9891' + phaseDetailRes.data.thumbnailPath
                        phaseRes.data.content[index]['isLoading'] = 'noLoad'
                        phaseRes.data.content[index]['centerx'] = phaseDetailRes.data.lon
                        phaseRes.data.content[index]['centery'] = phaseDetailRes.data.lat
                        this.setState({
                            totalElement: phaseRes.data.totalElements,
                            sensingImageDataList: phaseRes.data.content,
                        })
                    } else {
                        message.error('时相详情获取失败')
                    }
                })
            } else {
                message.error('专题集锦获取失败')
            }
        }).catch(e => {
            message.error('专题集锦获取失败')
        }).finally(() => {
            this.setState({
                spinning: false
            })
        })
    }

    /**
     *
     * @param pageNumber {number}
     * @param title
     * @returns {*}
     */
    getProductImageSource = async (pageNumber, title = '') => {
        let params = {
            title: title,
            data_type: 0,
            isAsc: 'DESC',
            layer_type: 0,
            orderByColumn: "createDate",
            page: pageNumber,
            size: 10
        }
        // const res = await axios.post(`/tif2tms/api/layer/query`, params);
        // const res = await axios.post(`http://caplos.aircas.ac.cn/tif2tms/api/layer/query`, params);
        this.setState({
            spinning: true,
            sensingImageDataList: []
        })
        await axios.post(`/tif2tms/api/layer/query`, params).then(res => {
            console.log('检查产品发布有关数据', sensingRes);
            const { data: sensingRes } = res
            if (sensingRes.code === 200) {
                if (sensingRes.data.content.length === 0) {
                    this.setState({
                        totalElement: 0,
                        currentPageNumber: 1
                    })
                }
                sensingRes.data.content && sensingRes.data.content.map(async (element, index) => {
                    const { data: thumbPathRes } = await axios.get(global.gatewayip + `/api/tms/prod2tms/getbyLayerName?layerName=${element.layername}`);
                    console.log('检查新接口返回的缩略图值:', thumbPathRes);
                    if (thumbPathRes.code === '200') {
                        // sensingRes.data.content[index]['thumbnailPath'] = '/tif2tmsdata' + thumbPathRes.data.thumbnailPath
                        sensingRes.data.content[index]['thumbnailPath'] = 'http://' + global.ip + thumbPathRes.payload;
                        sensingRes.data.content[index]['isLoading'] = 'noLoad'
                        this.setState({
                            sensingImageDataList: sensingRes.data.content,
                            totalElement: sensingRes.data.totalElements,
                        })
                    } else {
                        message.error('缩略图获取失败')
                    }
                })
            } else {
                message.error("遥感影像获取失败")
            }
        }).catch(e => {
            message.error("遥感影像获取失败")
        }).finally(() => {
            this.setState({
                spinning: false
            })
        })
    }


    /**
     * @description: 查看选中的数据详情
     * @event: checkSceneApplicationDataDetail
     * @param {*} currentCheckedData
     * @return {*}
     */
    checkSceneApplicationDataDetail = async (currentCheckedData) => {
        const { isSensingButtonChecked, isTopicUnityButtonChecked, isProductLaunchesButtonChecked } = this.state;

        if (isSensingButtonChecked) {
            await this.addCheckedSensingServerLayer(currentCheckedData)
        }
        if (isTopicUnityButtonChecked) {
            await this.addCheckedTopicServerLayer(currentCheckedData)
        }
        if (isProductLaunchesButtonChecked) {
            await this.addCheckedSensingServerLayer(currentCheckedData)
        }
        this.setState({
            switchSceneDetailStatus: 'block',
            switchSceneBoxDisplayStatus: 'none',
            currentcheckedSceneData: currentCheckedData,
        })
    }
    /**
     * @description: 加载查看的遥感影像数据数据到球上
     * @event: addCheckedSensingServerLayer
     * @param {*} checkedData
     * @return {*}
     */
    addCheckedSensingServerLayer = (checkedData) => {
        // let checkedDataArray = checkedData.previewUrl.split('?')
        // console.log((`http://124.16.188.131:8087${checkedData.tmsUrl}`).replace('y','reverseY'))
        // http://124.16.188.131:8087
        // let layers = checkedDataArray[1].split('&').map(element => {
        //   if (element.search('layers') != -1) {
        //     return element.split('=')[1]
        //   }
        // })
        // // console.log(layers)
        // this.WMTSLayer = this.props.earth.imageryLayers.addImageryProvider(
        //   new window.Geovis.WebMapServiceImageryProvider({
        //     url: checkedDataArray[0],
        //     layers: layers[3],
        //     parameters: {
        //       service:'WMS',
        //       format: 'image/png',
        //       transparent:true
        //     } ,
        //   })
        // )
        // let tmsUrl = (`http://124.16.188.131:8087${checkedData.tmsUrl}`).replace('{z}','11')
        let tmsUrl;
        if (this.state.isSensingButtonChecked) tmsUrl = ((`/getonlineImage${checkedData.tmsUrl}`).replace('y', 'reverseY'))
        else if (this.state.isProductLaunchesButtonChecked) tmsUrl = ((`https://caplos.aircas.ac.cn/tif2tms${checkedData.tmsUrl}`).replace('y', 'reverseY'))

        // let tmsUrl = ((`http://caplos.aircas.ac.cn/tif2tms${checkedData.tmsUrl}`).replace('y', 'reverseY'))
        // let tmsUrl = ((`http://124.16.188.131:8087${checkedData.tmsUrl}`))
        //  tmsUrl = tmsUrl.replace('y','reverseY')
        // tmsUrl = tmsUrl.replace('{x}', '3335')
        // console.log(tmsUrl)
        this.sensingServerLayer = this.props.earth.imageryLayers.addImageryProvider(
            new window.Geovis.UrlTemplateImageryProvider({
                url: tmsUrl,
                tileMatrixSetID: "EPSG:4326",
                tilingScheme: new window.Geovis.GeographicTilingScheme(),
            })
        )

        let timer = setTimeout(() => {
            this.props.earth.camera.flyTo({
                destination: window.Geovis.Cartesian3.fromDegrees(checkedData.centerx, checkedData.centery, 10000),
            })
            clearTimeout(timer)
        }, 1000)
    }

    controlSlider = () => {
        let _earth = this.props.earth
        if (!this.state.sliderShow) {
            this.props.setSliderShow(true)
            this.setState({
                sliderShow: true
            })
            this.sensingServerLayer.splitDirection = window.Geovis.SplitDirection.LEFT
            const slider = this.props.slider
            console.log('ccc', slider)
            this.props.earth.scene.splitPosition =
                slider.offsetLeft / slider.parentElement.offsetWidth;
            const handler = new window.Geovis.ScreenSpaceEventHandler(slider);
            let moveActive = false;

            function move(movement) {
                if (!moveActive) {
                    return;
                }

                const relativeOffset = movement.endPosition.x;
                const splitPosition =
                    (slider.offsetLeft + relativeOffset) /
                    slider.parentElement.offsetWidth;
                slider.style.left = `${100.0 * splitPosition}%`;
                _earth.scene.splitPosition = splitPosition;
            }

            handler.setInputAction(function () {
                moveActive = true;
            }, window.Geovis.ScreenSpaceEventType.LEFT_DOWN);
            handler.setInputAction(function () {
                moveActive = true;
            }, window.Geovis.ScreenSpaceEventType.PINCH_START);

            handler.setInputAction(move, window.Geovis.ScreenSpaceEventType.MOUSE_MOVE);
            handler.setInputAction(move, window.Geovis.ScreenSpaceEventType.PINCH_MOVE);

            handler.setInputAction(function () {
                moveActive = false;
            }, window.Geovis.ScreenSpaceEventType.LEFT_UP);
            handler.setInputAction(function () {
                moveActive = false;
            }, window.Geovis.ScreenSpaceEventType.PINCH_END);
        } else {
            this.props.setSliderShow(false)
            this.setState({
                sliderShow: false
            })
            this.sensingServerLayer.splitDirection = 0
        }
    }


    /**
     * @description: 加载查看的专题集锦数据数据到球上
     * @event: addCheckedTopicServerLayer
     * @param {*} checkedData
     * @return {*}
     */
    addCheckedTopicServerLayer = async (checkedData) => {
        let arr = []
        const { data: res } = await axios.get(`/getonlineImage/api/layer/timePhaseShow/${checkedData.id}`)
        // console.log(res)
        if (res.code === 200) {
            arr = Object.keys(res.data.timeSeries).map(item => {
                return item.replace(" ", "T")
            })
            this.addTimingImageSample(arr, checkedData.centerx, checkedData.centery, checkedData.id)
        } else {
            message.error('时间获取失败')
        }
    }
    /**
     * @description: 添加时相图层
     * @event: addTimingImageSample
     * @return {*}
     */
    addTimingImageSample = (timeArray, centerx, centery, layerId) => {
        document.getElementsByClassName("cesium-viewer-timelineContainer")[0].style.display = "block"
        document.getElementsByClassName("cesium-viewer-animationContainer")[0].style.display = "block"

        this.props.earth.camera.flyTo({
            destination: window.Geovis.Cartesian3.fromDegrees(centerx, centery, 100000),
        })

        const startTime = window.Geovis.JulianDate.fromIso8601(timeArray[0])
        const endTime = window.Geovis.JulianDate.fromIso8601(timeArray[timeArray.length - 1])
        this.props.earth.timeline.zoomTo(startTime, endTime)

        const clock = this.props.earth.clock
        clock.startTime = startTime
        clock.endTime = endTime
        clock.currentTime = startTime
        clock.clockRange = window.Geovis.ClockRange.LOOP_STOP

        let timer = setTimeout(() => {
            clock.multiplier = 86400 * 30

            this.TopicServerLayer = this.props.earth.imageryLayers.addImageryProvider(
                new window.Geovis.GvUrlTemplateImageryProvider({
                    url: `/getonlineImage/api/tms/${layerId}/{Time}/{z}/{reverseY}/{x}`,
                    tileMatrixSetID: "EPSG:4326",
                    tilingScheme: new window.Geovis.GeographicTilingScheme(),
                    clock: clock,
                    times: this.getSpecialTimes(timeArray)
                })
            )
            clearTimeout(timer)
        }, 5000)
    }
    /**
     * @description: 动态获取url上的时间
     * @event:
     * @param {*} timeArray
     * @return {*}
     */
    getSpecialTimes = (timeArray) => {
        return window.Geovis.TimeIntervalCollection.fromIso8601DateArray({
            iso8601Dates: timeArray,
            leadingInterval: true,
            trailingInterval: true,
            dataCallback: (interval, index) => {
                let time = window.Geovis.JulianDate.toDate(interval.start).getTime()
                return function () {
                    return time
                }
            }
        })
    }
    /**
     * @description: 清除加载的图层
     * @event: clearCheckedServerLayer
     * @return {*}
     */
    clearCheckedServerLayer = () => {
        this.props.earth.scene.imageryLayers && this.props.earth.scene.imageryLayers.remove(this.sensingServerLayer);
        this.props.earth.scene.imageryLayers && this.props.earth.scene.imageryLayers.remove(this.TopicServerLayer);
    }
    /**
     * @description: 改变页码，查询数据
     * @event:
     * @param {*} pageNumber
     * @return {*}
     */
    changePageNumber = (pageNumber) => {
        const {
            isSensingButtonChecked,
            isTopicUnityButtonChecked,
            searchKeyword,
            isProductLaunchesButtonChecked
        } = this.state
        this.setState({
            currentPageNumber: pageNumber
        }, async () => {
            if (isSensingButtonChecked) {
                await this.getSensingImageSource(pageNumber, searchKeyword)
            }
            if (isTopicUnityButtonChecked) {
                await this.getPhaseImageSource(pageNumber, searchKeyword)
            }
            if (isProductLaunchesButtonChecked) {
                await this.getProductImageSource(pageNumber, searchKeyword)
            }
        })

    }
    /**
     * @description: 获取检索框中的数据
     * @event:
     * @param {*} value
     * @return {*}
     */
    searchInputValuechanged = (event) => {
        // console.log(event.target.value)
        this.setState({
            searchKeyword: event.target.value
        })
    }

    /**
     * @description: 根据关键字检索出结果
     * @event:
     * @return {*}
     */

    searchKeyWordServers = async () => {
        const { isSensingButtonChecked, isTopicUnityButtonChecked, searchKeyword } = this.state
        if (isSensingButtonChecked) {
            await this.getSensingImageSource(1, searchKeyword)
        }
        if (isTopicUnityButtonChecked) {
            await this.getPhaseImageSource(1, searchKeyword)
        }
    }

    render() {
        const {
            isSensingButtonChecked,
            isTopicUnityButtonChecked,
            switchSceneBoxDisplayStatus,
            sensingImageDataList,
            switchSceneDetailStatus,
            currentcheckedSceneData,
            currentPageNumber,
            totalElement,
            searchKeyword,
            isProductLaunchesButtonChecked,
            spinning
        } = this.state
        // console.log(sensingImageDataList)
        return (
            <>
                {/* 场景应用弹窗 */}
                <div className="scene-application" id="scene-application"
                    style={{ display: switchSceneBoxDisplayStatus }}>
                    <div className="scene-application-box-wrap">
                        <div className="scene-application-box-title">
                            <div className="scene-application-box-title-text">场景应用</div>
                            <div className="scene-application-box-title-close-button" onClick={this.closeSceneBox}>X
                            </div>
                        </div>
                        <Spin spinning={spinning}>

                            <div className="scene-application-box-toolarea">
                                <div
                                    className={isSensingButtonChecked ? "scene-application-box-sensing-images-button-checked" : "scene-application-box-sensing-images-button"}
                                    onClick={() => {
                                        this.switchDisplayImage('遥感影像')
                                    }}
                                >遥感影像
                                </div>
                                <div
                                    className={isTopicUnityButtonChecked ? "scene-application-box-topic-unite-button-checked" : "scene-application-box-topic-unite-button"}
                                    onClick={() => {
                                        this.switchDisplayImage('专题集锦')
                                    }}
                                >专题集锦
                                </div>
                                <div
                                    className={isProductLaunchesButtonChecked ? "scene-application-box-topic-unite-button-checked" : "scene-application-box-topic-unite-button"}
                                    onClick={() => {
                                        this.switchDisplayImage('产品发布')
                                    }}
                                >产品发布
                                </div>
                                <div className="scene-application-box-search-wrap">
                                    <input
                                        className="scene-application-box-search-input"
                                        placeholder="请输入影像标题"
                                        value={searchKeyword}
                                        onChange={(event) => this.searchInputValuechanged(event)}
                                    >
                                    </input>
                                    <img src={searchIcon} className="scene-application-box-search-icon"
                                        onClick={() => this.searchKeyWordServers()}></img>
                                </div>
                            </div>
                            <div className="scene-application-box-displayarea">
                                {
                                    sensingImageDataList.length === 0 ?
                                        <>
                                            <div className="scene-application-box-displayarea-nodata">
                                                <img src={nodata}
                                                    className="scene-application-box-displayarea-nodata-img"></img>
                                            </div>
                                        </> :
                                        <>
                                            {
                                                sensingImageDataList.map((element, index) => {
                                                    // console.log('中心经纬度',element.centerx,'       ',element.centery)
                                                    // console.log('缩略图地址',element.thumbnailPath)
                                                    return (<>
                                                        <div key={element.id + index}
                                                            className="scene-application-box-display-item-wrap"
                                                            onClick={() => {
                                                                this.checkSceneApplicationDataDetail(element)
                                                            }}>
                                                            <Skeleton active={true} loading={!element.isLoading} className="scene-application-box-display-thumb">
                                                                <img src={element.thumbnailPath}
                                                                    className="scene-application-box-display-thumb" alt='加载失败'></img>
                                                            </Skeleton>
                                                            <div
                                                                className="scene-application-box-display-name">{element.title}</div>
                                                            {
                                                                element.centerx && element.centery ? <div
                                                                    className="scene-application-box-display-position">坐标:{element.centerx.toFixed(4) + ',' + element.centery.toFixed(4)}</div> :
                                                                    <div
                                                                        className="scene-application-box-display-position">坐标:</div>
                                                            }
                                                        </div>
                                                    </>)
                                                })
                                            }
                                        </>
                                }
                            </div>
                            {
                                sensingImageDataList.length === 0 ?
                                    <></> :
                                    <><Pagination
                                        className="scene-application-box-pagination"
                                        simple
                                        current={currentPageNumber}
                                        total={totalElement}
                                        onChange={(page) => {
                                            this.changePageNumber(page)
                                        }}
                                    /></>
                            }
                        </Spin>
                    </div>
                </div>
                {/* 场景应用详情框 */}
                <div className="scene-application-detail" style={{ display: switchSceneDetailStatus }}>
                    <div className="scene-application-detail-title">
                        <img src={dataDetail} className="scene-application-detail-title-icon"></img>
                        详情
                    </div>
                    <div className="scene-application-detail-content">
                        <img src={currentcheckedSceneData.thumbnailPath}
                            className="scene-application-detail-thumb"></img>
                        <div
                            className="scene-application-detail-thumb-infomation">名称：{currentcheckedSceneData.title}</div>
                        <div
                            className="scene-application-detail-thumb-infomation">中心经度：{currentcheckedSceneData.centerx}</div>
                        <div
                            className="scene-application-detail-thumb-infomation">中心维度：{currentcheckedSceneData.centery}</div>
                        <div
                            className="scene-application-detail-thumb-infomation">发布时间：{currentcheckedSceneData.createDate}</div>
                        <div
                            className="scene-application-detail-thumb-infomation">最小层级：{currentcheckedSceneData.minlevel}</div>
                        <div
                            className="scene-application-detail-thumb-infomation">最大层级：{currentcheckedSceneData.maxlevel}</div>
                        <div className="scene-application-detail-analysis" style={{ display: isTopicUnityButtonChecked ? 'none' : 'flex' }} onClick={() => this.controlSlider()}>卷帘分析</div>
                    </div>
                    <div className="scene-application-detail-oprateArea">
                        <div className="scene-application-detail-close-button" onClick={() => {
                            this.closeScendDetailBox()
                        }}>关闭
                        </div>
                        <div className="scene-application-detail-back-button" onClick={() => {
                            this.backScendDisplayBox()
                        }}>返回专题
                        </div>
                    </div>
                </div>

            </>
        )
    }
}
